import React from 'react';
import styled, {css} from 'styled-components';

import {selectStyle} from '../styles/includes/forms';

const StyledSelect = styled.select`
  ${selectStyle}
  width: 100%;
`

interface props {
  children: any;
}

export default React.forwardRef((props:props, ref) => {
    return (
        <StyledSelect {...props} ref={ref}>{props.children}</StyledSelect>
    )
});